module.exports = __webpack_public_path__ + "img/houses.1c8c611c.svg";